import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import pcobanner_desktop from '../../../images/pc-optimum-banner.svg';
import pcobanner_desktop_sm from '../../../images/pc-optimum-banner-desktop-sm.svg';
import pcobanner_desktop_lg from '../../../images/pc-optimum-banner-desktop-lg.svg';
import pcobanner_tablet from '../../../images/pc-optimum-banner-tablet.svg';
import pcobanner_mobile from '../../../images/pc-optimum-banner-mobile.svg';
import red_confetti from '../../../images/red-confetti.png';

export const Wrapper = styled.div`
  position: relative;
  background-color: ${({ backgroundColor }) =>
    themeGet(`colors.${backgroundColor}`)};
  background-image: url(${({ backgroundImage }) =>
    backgroundImage ? backgroundImage.asset.localImage.publicURL : ''});
  background-size: cover;
  background-position: top right;
  background-repeat: no-repeat;

  &.title-with-statement-wrapper,
  &.pcf-product-block-wrapper {
    padding: 1px 0;
  }

  &.pco-earn-section-wrapper {
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${pcobanner_mobile});

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background-image: url(${pcobanner_tablet});
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      background-image: url(${pcobanner_desktop});
    }

    @media only screen and (min-width: 1680px) {
      background-image: url(${pcobanner_desktop_sm});
    }

    @media only screen and (min-width: 1920px) {
      background-image: url(${pcobanner_desktop_lg});
    }
  }

  &.pavilion-cleanliness-wrapper {
    background: linear-gradient(
      to bottom,
      transparent 85%,
      ${themeGet('colors.pc-red', '#E1251B')} 15%
    );
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background: linear-gradient(
        to bottom,
        transparent 75%,
        ${themeGet('colors.pc-red', '#E1251B')} 25%
      );
    }
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      background: linear-gradient(
        to bottom,
        transparent 60%,
        ${themeGet('colors.pc-red', '#E1251B')} 40%
      );
    }
  }

  &.pcma-points-block-wrapper {
    padding: 15px 0;
  }

  &.application-blade-wrapper {
    width: 100%;
  }

  &.overflowX-auto-margin-wrapper,
  &.overflowX-wrapper {
    overflow-x: hidden;
  }

  &.pcma-list-section-wrapper {
    padding: 0.5rem;
  }

  &.product-card-wrapper {
    margin-bottom: 10rem;
  }

  &.pcma-hero-wrapper {
    background: ${({ backgroundColor }) =>
      themeGet(`colors.${backgroundColor}`)};

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background: linear-gradient(
        ${({ backgroundColor }) => themeGet(`colors.${backgroundColor}`)} 0%,
        ${({ backgroundColor }) => themeGet(`colors.${backgroundColor}`)} 85%,
        ${themeGet('colors.light-grey', '#F6F6F7')} 85%
      );
    }
  }

  &.pcma-split-width-wrapper {
    padding: 0.1rem;
    color: ${({ backgroundColor }) =>
      ['velvet', 'pc-red'].includes(backgroundColor)
        ? themeGet(`colors.white`)
        : themeGet(`colors.main-text`)};
  }

  &.pc-points-day-wrapper {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background:
        url(${red_confetti}) no-repeat top right,
        ${({ backgroundColor }) => themeGet(`colors.${backgroundColor}`)};
      background-size: 50% auto;
      background-repeat-y: repeat;
    }
  }

  &.spotlight-wrapper {
    width: calc(100% + 4.5rem);
    margin: 0 -2.25rem 0;
    padding: 1rem 2.25rem;
    align-content: center;
  }

  &.hero-carousel-container-wrapper {
    box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.2);
  }
`;

export const Grid = styled.div`
  position: relative;
  margin: 40px auto;
  max-width: ${themeGet('media.grid')};
  // * calc(100% - 30px) gives us 15px margin on the left and right of the grid container on a mobile view
  width: calc(100% - ${themeGet('media.grid-gutter.2')});
  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.2')});
  }
  // * calc(100% - 60px) gives us 30px margin on the left and right of the grid container on a tablet view
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
    margin: 70px auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.5')});
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 100px auto;
  }

  &.pcma-split-width {
    margin: 70px auto;
    text-align: center;
  }

  &.pcma-list-section {
    width: 100%;
  }

  &.overflowX-auto-margin,
  &.auto-margin {
    margin: 0 auto;
  }

  &.no-margin {
    margin: 0 !important;
  }

  &.negative-bottom-margin {
    margin-bottom: -40px;
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-bottom: -70px;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin-bottom: -100px;
    }
  }

  &.inner-container {
    margin: 40px 0;
    width: 100%;
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 70px 0;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 100px 0;
    }
  }

  &.flex-centered {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  &.justify-center {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  &.text-center {
    text-align: center;
  }

  &.hero {
    margin: 40px auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 60px auto 70px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 90px auto 100px;
    }

    &.hero-with-optimum-half-circles {
      width: 100%;

      @media only screen and (max-width: calc(${themeGet(
          'breakpoints.md',
        )} - 1px)) {
        margin-top: 0;
      }
    }

    &.pc-optimum-hero {
      margin: 40px auto 80px;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        margin: 60px auto 120px;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        margin: 80px auto 160px;
      }
    }

    &.static-split-width-content,
    &.static-hero-image-overflow {
      margin: 0 auto;
    }
  }

  &.learning-hub {
    margin: 56px auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 80px auto;
    }
  }

  &.legal-details {
    margin: 50px auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 50px auto 60px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 80px auto 100px;
    }
  }

  &.media-centre {
    width: 100%;
    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      width: calc(100% - ${themeGet('media.grid-gutter.3')});
    }
    // * calc(100% - 60px) gives us 30px margin on the left and right of the grid container on a tablet view
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: calc(100% - ${themeGet('media.grid-gutter.3')});
      margin: 70px auto;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 100px auto;
    }
  }

  &.static-full-width-content {
    margin-bottom: 40px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-bottom: 60px;
    }
  }

  &.static-digital-banking-overview {
    width: 100%;
    margin: 0 auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: calc(100% - ${themeGet('media.grid-gutter.3')});
    }
  }

  &.covid-19 {
    height: 40vh;
  }

  ${Wrapper}.pavilion-cleanliness-wrapper & {
    margin: 0 auto;
    padding: 50px 0 100px;
  }

  ${Wrapper}.abm-pavilion-map-wrapper & {
    margin: 0 auto;
    padding: 70px 0 100px;
  }

  &.pcma-hero {
    margin: auto;
    width: 100%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: calc(100% - ${themeGet('media.grid-gutter.4')});
      margin: 0 auto;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: calc(100% - ${themeGet('media.grid-gutter.5')});
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 0 auto;
    }
  }

  &.animated-credit-cards,
  &.animated-multi-product {
    margin: auto;
    width: calc(100% - ${themeGet('media.grid-gutter.2')});

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      width: calc(100% - ${themeGet('media.grid-gutter.3')});
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 40px auto 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 65px auto 0;
    }
  }

  &.animated-credit-cards {
    margin-bottom: 80px;
  }

  &.animated-campaign-email {
    margin: auto 0;
    width: 100%;
    max-width: 100%;
    display: flex;
  }

  &.video-tutorials {
    margin: 40px auto 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 60px auto 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 90px auto 0;
    }
  }

  &.product-device-step {
    margin: 30px auto;
  }

  &.animated-sliding-cover {
    margin: auto;
    width: calc(100% - ${themeGet('media.grid-gutter.2')});
    min-width: 320px;

    // galaxy fold
    @media only screen and (min-width: 279px) {
      min-width: 280px;
    }

    @media only screen and (min-width: 360px) {
      min-width: 375px;
      width: calc(100% - ${themeGet('media.grid-gutter.3')});
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: calc(100% - ${themeGet('media.grid-gutter.3')});
      margin: 0 auto 40px;
    }
  }

  &.pc-points-day,
  &.saving-calculator {
    width: 100%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: calc(100% - ${themeGet('media.grid-gutter.3')});
    }
  }

  &.selectable-card.chart {
    padding-top: 40px;
    margin: 0 auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding-top: 70px;
    }
  }

  &.spotlight,
  &.rating-and-testimonial {
    width: 100%;
  }

  &.hero-carousel {
    @media only screen and (min-width: 1320px) {
      width: 100%;
    }
  }

  &.hero-carousel-container {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 100%;
    }
  }

  ${({ $hasBgImg }) =>
    $hasBgImg &&
    css`
      &.points-feature-section {
        padding: 1rem 0;
        @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
          padding: 2rem 0;
        }
        @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
          padding: 3rem 0;
        }
      }
    `}

  ${({ $hasBgColor }) =>
    $hasBgColor &&
    css`
      &.simple-image-banner {
        padding: 1px 0;
      }
    `}
`;
